<template>
  <div class="button-wrapper p-4">
    <button
      :disabled="disabled"
      :type="type"
      :id="id"
      @click="$emit('click')"
      class="px-10 py-4 rounded-sm"
    >{{ label }}</button>
  </div>
</template>

<script>
export default {
  props: ["type", "id", "label", "disabled"]
};
</script>

<style lang="scss" scoped>
.button-wrapper {
  display: block;
  overflow: hidden;
  text-align: right;
  button {
    display: inline-block;
    background: #FFCD50;
    color: #fff;
    font-weight: 600;
    text-transform: uppercase;
    &:disabled {
      background: #4a4a4a;
      cursor: not-allowed;
    }
  }
}

@media screen and (max-width: 767px) {
  .button-wrapper {
    padding: 1em 0 0;

    button {
      padding: 1rem 2em;
      margin: 0 auto;
      text-align: center;
      width: 100%;
    }
  }
}
</style>
